export default __webpack_public_path__ + "static/bba-best-banking-app-4a55dd9b875a609b82ba63aa9d5a6472.png";